<script>
// import Translations from "./insert-me-to-translate.vue";

import Recaptcha from './recaptcha';
import Hcaptcha from './hcaptcha';
import {mapGetters} from "vuex";
import {isValidEmail} from "../services/email_validator";

export default {
    props: ['initEmail', 'initEmailError', 'initPassword', 'initPasswordError', 'initRecaptchaError', 'initGeneralError'],

    components: {
        Recaptcha,
        Hcaptcha,
        UiAlert: () => import(/* webpackChunkName: "chunk-ui-alert" */ './ui/ui-alert.vue'),
    },

    data: function(){
        return  {
            isPasswordVisible: false,
            email: this.initEmail,
            emailError: this.initEmailError,
            password: this.initPassword,
            passwordError: this.initPasswordError,
            recaptchaError: this.initRecaptchaError,
            generalError: this.initGeneralError,
            isRecaptchaFilled: true,
            submittedForm: false,
        };
    },

    computed: {
        ...mapGetters({
            isRecaptchaReady: 'ui/recaptcha/isReady',
            recaptchaResponse: 'ui/recaptcha/response',
        }),
    },

    methods: {
        onEyeClick: function(event){
            this.isPasswordVisible = !this.isPasswordVisible
        },
        validate: function(event){
            this.emailError = '';
            this.passwordError = '';
            this.recaptchaError = '';
            this.isRecaptchaFilled = !!this.recaptchaResponse;

            if(isValidEmail(this.email.trim()) && this.password.trim() && this.isRecaptchaFilled){
                this.submittedForm = true;
                return true;
            }else{
                if(!this.email.trim()){
                    this.emailError = gettext('Please fill in this field')
                } else if(!isValidEmail(this.email.trim())){
                    this.emailError = gettext('This is not a valid email');
                }
                if(!this.password.trim()){
                    this.passwordError = gettext('Please fill in this field')
                }
                if(!this.isRecaptchaFilled) this.recaptchaError = gettext('Please fill in this field');

            }

           // go to first error after dom updates
            this.$nextTick().then(()=>{
                this.$skokka.scrollToError();
            });
            event.preventDefault()
        },
    },
};

</script>
